import { track } from '@eventbrite/datalayer-library';
import { Icon } from '@eventbrite/eds-icon';
import { ArrowRightChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { TrackableComponent } from '../../../../utils/TrackableComponent';
import { PLACE_ID_TO_DATING_COLLECTION_MAP } from '../../constants/dating';
import { HEAP_TRACKABLE_EVENT } from '../../constants/heap';
import styles from './MariaTouchpoint.module.scss';

const title = gettext('EXPERT PICKS');
const subtitle = gettext('Meet your match');
const description = gettext(
    'Date ideas from Matchmaker Maria, CEO of Agape Matchmaking',
);

interface MariaTouchpointProps {
    placeId: string;
}

export const MariaTouchpoint = (props: MariaTouchpointProps) => {
    const { placeId } = props;
    const ctaLink = `/c/${PLACE_ID_TO_DATING_COLLECTION_MAP[placeId]}`;

    const handleIntersect = () => {
        track({
            eventName: HEAP_TRACKABLE_EVENT,
            eventData: {
                eventBucketLabel: 'maria_touchpoint',
            },
        });
    };

    if (
        !Object.hasOwnProperty.call(PLACE_ID_TO_DATING_COLLECTION_MAP, placeId)
    ) {
        return null;
    }

    return (
        <TrackableComponent onIntersect={handleIntersect}>
            <div className={styles.touchpoint}>
                <div className={styles.mariaImg}></div>
                <div className={styles.touchpointDetails}>
                    <Typography className={styles.title} variant="body-md">
                        {title}
                    </Typography>
                    <Typography
                        className={styles.subtitle}
                        variant="heading-sm"
                    >
                        {subtitle}
                    </Typography>
                    <Typography
                        className={styles.description}
                        variant="body-md"
                    >
                        {description}
                    </Typography>
                </div>
                <a
                    className={styles.exploreBtn}
                    href={ctaLink}
                    data-heap-id={'datingPage-mariaCollection'}
                >
                    <Typography
                        className={styles.exploreBtnTypo}
                        variant="body-md-bold"
                    >
                        {gettext('Explore')}{' '}
                        <Icon type={<ArrowRightChunky />} />
                    </Typography>
                </a>
            </div>
        </TrackableComponent>
    );
};
